var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyVotesDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2.00008H10V0.666748H8.66667V2.00008H3.33333V0.666748H2V2.00008H1.33333C0.593333 2.00008 0 2.60008 0 3.33341V12.6667C0 13.4001 0.593333 14.0001 1.33333 14.0001H10.6667C11.4 14.0001 12 13.4001 12 12.6667V3.33341C12 2.60008 11.4 2.00008 10.6667 2.00008ZM10.6667 12.6667H1.33333V6.00008H10.6667V12.6667ZM10.6667 4.66675H1.33333V3.33341H10.6667V4.66675ZM2.66667 7.33341H6V10.6667H2.66667V7.33341Z",
    fill: "#363B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyVotesDataIcon);
export default __webpack_public_path__ + "static/media/MyVotes_data_icon.13de2fb89ce6c2ae902d8920e28ee473.svg";
export { ForwardRef as ReactComponent };